
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash-message"
export default class extends Controller {
  TIMEOUT = 2000;

  connect() {
    setTimeout(() => {
      this.element.remove();
    }, this.TIMEOUT);
  }
}
